module.exports = __webpack_public_path__ + "static/media/landing-bgImg-md.f5e4b5d6.png";